import React, { SVGProps } from 'react';

export const UploadSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_4615_834)'>
        <path
          d='M8.00061 10.1875V3.1875M8.00061 3.1875L10.6256 5.8125M8.00061 3.1875L5.37561 5.8125M14.5631 10.1875V11.0625C14.5631 11.5266 14.3787 11.9717 14.0505 12.2999C13.7224 12.6281 13.2772 12.8125 12.8131 12.8125H3.18811C2.72398 12.8125 2.27886 12.6281 1.95067 12.2999C1.62248 11.9717 1.43811 11.5266 1.43811 11.0625V10.1875'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4615_834'>
          <rect width='14' height='14' fill='white' transform='translate(1 1)' />
        </clipPath>
      </defs>
    </svg>
  );
};
